import { Component, OnInit } from '@angular/core';
import { AjaxService } from '../../../service/ajax.service';
import { API } from 'src/environments/environment';
import { UserService } from 'src/app/services/user.service';

interface Processo {
  id: number;
  numero: string;
  tipo: string;
  status: string;
  dataCriacao: Date;
  ultimaAtualizacao: Date;
}

interface Notificacao {
  id: number;
  titulo: string;
  mensagem: string;
  data: Date;
  lida: boolean;
}

@Component({
  selector: 'app-home-cliente',
  templateUrl: './home-cliente.component.html',
  styleUrls: ['./home-cliente.component.scss']
})
export class HomeClienteComponent implements OnInit {
  processos: Processo[] = [];
  notificacoes: Notificacao[] = [];
  loading: boolean = false;
  errorMessage: string = '';
  user: any;

  constructor(
    private ajaxService: AjaxService,
    private auth: UserService
  ) {}

  ngOnInit() {
    this.user = this.auth.getUser();
    this.carregarDados();
  }

  private carregarDados() {
    this.loading = true;
    this.errorMessage = '';

    // Carrega processos
    this.ajaxService.get(API + 'Processo/GetProcessos?ID_USUARIO=' + this.user.Id).subscribe({
      next: (response) => {
        if (response.data && Array.isArray(response.data)) {
          this.processos = response.data.map(proc => ({
            id: proc.iD_PROCESSO,
            numero: proc.numero,
            tipo: proc.tipo,
            status: proc.status,
            dataCriacao: new Date(proc.datA_CRIACAO),
            ultimaAtualizacao: new Date(proc.datA_ATUALIZACAO)
          }));
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Erro ao carregar processos:', error);
        this.errorMessage = 'Erro ao carregar processos. Tente novamente.';
        this.loading = false;
      }
    });

    // Carrega notificações
    this.ajaxService.get(API + 'Notificacao/GetNotificacoes?ID_USUARIO=' + this.user.Id).subscribe({
      next: (response) => {
        if (response.data && Array.isArray(response.data)) {
          this.notificacoes = response.data.map(notif => ({
            id: notif.iD_NOTIFICACAO,
            titulo: notif.titulo,
            mensagem: notif.mensagem,
            data: new Date(notif.datA_NOTIFICACAO),
            lida: notif.lida
          }));
        }
      },
      error: (error) => {
        console.error('Erro ao carregar notificações:', error);
      }
    });
  }

  marcarNotificacaoComoLida(notificacao: Notificacao) {
    if (!notificacao.lida) {
      this.ajaxService.post(API + 'Notificacao/MarcarComoLida', { id: notificacao.id }).subscribe({
        next: () => {
          notificacao.lida = true;
        },
        error: (error) => {
          console.error('Erro ao marcar notificação como lida:', error);
        }
      });
    }
  }

  formatarData(data: Date): string {
    return data.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }

  getStatusClass(status: string): string {
    switch (status.toLowerCase()) {
      case 'em andamento':
        return 'status-andamento';
      case 'concluído':
        return 'status-concluido';
      case 'aguardando':
        return 'status-aguardando';
      default:
        return '';
    }
  }
} 